// Super-admin client for /api/admin/bug-reports + /api/admin/integrations/jira.
import adminAxios from "./adminAxios";

const bugReportsAdmin = {
  // ── Bug reports ───────────────────────────────────────────────
  search: (params) => adminAxios.get("/bug-reports", { params }),
  get: (id) => adminAxios.get(`/bug-reports/${id}`),
  update: (id, body) => adminAxios.patch(`/bug-reports/${id}`, body),
  createJira: (id) => adminAxios.post(`/bug-reports/${id}/jira`),

  // ── JIRA settings ─────────────────────────────────────────────
  getJiraConfig: () => adminAxios.get("/integrations/jira"),
  updateJiraConfig: (body) => adminAxios.put("/integrations/jira", body),
};

export default bugReportsAdmin;
